var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10, _rect11, _rect12, _rect13, _path2, _rect14, _rect15, _rect16, _rect17, _path3, _rect18, _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlaylistDark = function SvgPlaylistDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#1D192D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 126,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 55.5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#272339"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 52.75,
    width: 54.5,
    height: 54.5,
    rx: 9.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.793 86.055c-1.337.8-3.034-.168-3.027-1.725l.04-8.675c.008-1.554 1.707-2.507 3.036-1.702l7.19 4.352c1.29.78 1.284 2.654-.01 3.427l-7.23 4.323Z",
    fill: "#56516A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 99.25,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 55.5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 52,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#272339"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 124.75,
    y: 52.75,
    width: 54.5,
    height: 54.5,
    rx: 9.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.793 86.055c-1.337.8-3.034-.168-3.027-1.725l.04-8.675c.008-1.554 1.707-2.507 3.036-1.702l7.189 4.352c1.29.78 1.285 2.654-.009 3.427l-7.229 4.323Z",
    fill: "#56516A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 129.25,
    y: 99.25,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56.125,
    y: 45.875,
    width: 78,
    height: 78,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 41,
    width: 78,
    height: 78,
    rx: 10,
    fill: "#272339"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 61.75,
    y: 41.75,
    width: 76.5,
    height: 76.5,
    rx: 9.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.73 89.15c-1.336.798-3.033-.17-3.026-1.727l.068-14.862c.007-1.554 1.707-2.507 3.036-1.702l12.317 7.456c1.29.781 1.285 2.654-.009 3.428L95.73 89.149Z",
    fill: "#56516A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 68.313,
    y: 106.812,
    width: 31.688,
    height: 4.875,
    rx: 2.438,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 80,
    fill: "url(#playlist-dark_svg__a)",
    fillOpacity: 0.04
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "playlist-dark_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.552 80.552) scale(79.4483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF",
    stopOpacity: 0
  })))));
};

export { SvgPlaylistDark as ReactComponent };
export default "data:image/svg+xml;base64,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";